import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=621bf407&scoped=true&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"
import style0 from "./Modal.vue?vue&type=style&index=0&id=621bf407&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621bf407",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('621bf407')) {
      api.createRecord('621bf407', component.options)
    } else {
      api.reload('621bf407', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=621bf407&scoped=true&", function () {
      api.rerender('621bf407', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Interpreting/Modal.vue"
export default component.exports